module.exports = __webpack_public_path__ + "media/images/sp/accessories/men/men_03_thumb-dccf65f695af9f9ef4f7e3e0465cad68.jpg";